import { OrganizationContainer } from './OrganizationContainer';
export default OrganizationContainer;
